module.exports = __webpack_public_path__ + "static/media/truck.424fe257.svg";